import React, { FC } from 'react';
import { useRouter } from 'next/router';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Button from '@/components/UI/button/Button';
import styles from './MobileActiveReserveStatus.module.scss';
type MobileActiveReserveStatusProps = {
  orderId: string;
};
const MobileActiveReserveStatus: FC<MobileActiveReserveStatusProps> = ({
  orderId
}) => {
  const router = useRouter();
  const handleToLastReserve = () => {
    const id = orderId;
    router.push(`/order-tracking/${id}/show`);
  };
  return <Box className={styles['active-reserves']} data-sentry-element="Box" data-sentry-component="MobileActiveReserveStatus" data-sentry-source-file="MobileActiveReserveStatus.tsx">
      <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="MobileActiveReserveStatus.tsx">
        برای این اقامتگاه رزرو فعال دارید.
      </Typography>
      <Box data-sentry-element="Box" data-sentry-source-file="MobileActiveReserveStatus.tsx">
        <Button size="small" format="outlined" onClick={handleToLastReserve} data-sentry-element="Button" data-sentry-source-file="MobileActiveReserveStatus.tsx">
          مشاهده جزییات
        </Button>
      </Box>
    </Box>;
};
export default MobileActiveReserveStatus;